<div class="row ss-top-menu">
  <div class="col-6">
    <span class="ss-text-dark" style="vertical-align: -webkit-baseline-middle;">Sales Manager</span>
  </div>
</div>

<!-- <div class="row">
  <div class="rk-ui-notification err" *ngIf="erroralert">
    <span id="notificationMessageText">{{errorMessage}}</span>
    <a class="close rk-linknotification" (click)="erroralert=false">×</a>
  </div>
  <div class="col-12" *ngIf="successalert">
    <div class="alert-box grid-100" *ngIf="successMessage">
      <div class="alert alert-success mt-3 text-center">
        <a class="close link" data-dismiss="alert"  (click)="successalert=false">×</a>
        {{successMessage}}
      </div>
    </div>
  </div>
</div> -->



<div class="row body_height justify-content-center">
  <div class="col-12">
    <ng-container>
    <h5 *ngIf="sm_list && sm_list.length == 0" class="text-center my-5">No leads Available</h5>
    <div class="tableDiv lappyView">
      <table class="table" >
        <thead class="ss-thead">
          <tr>
            <th class="firstTh" style="min-width: 1rem;">#</th>

            <th>NAME</th>

            <th>MOBILE NUMBER</th>

            <th>EMAIL ID</th>

            <th class="text-center">ASSIGNED CM</th>
          </tr>

        </thead>

        <tbody class="ss-tbody" *ngIf="sm_list && sm_list.length > 0">
          <!-- <tr *ngFor="let sm of sm_list; let i = index">  -->
            <tr *ngFor="let sm of sm_list; let i = index">

            <td>{{i+1}}</td>
            <td style="min-width: 1rem;">{{sm.name}}</td>
            <td style="min-width: 1rem;">{{sm.contact}}</td>
            <td style="min-width: 1rem;">{{sm.email}}</td>
            <td  class="text-center "  style="min-width: 1rem;"><a [ngClass]="sm.cm_count > 0 ? 'maxcount' : 'mincount'" data-toggle="modal" data-target="#CMdetailsModal" (click)="openModal(sm.id)">{{sm.cm_count}}</a></td>
          </tr>
          
            
        </tbody>

      </table>
      
    </div>
    </ng-container>


  </div>
</div>  

<!-- pop-up tab for cm details -->
<div class="modal fade customModal" id="CMdetailsModal" tabindex="-1" role="dialog" aria-labelledby="CMdetailsModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title modalTitle" id="CMdetailsModalLabel">CM Details</h5>
        <button type="button" class="close addCursor" data-dismiss="modal">&times;</button>

      </div>

      <div class="modal-body">
        <ng-container>
          <h5 *ngIf="cm_list && cm_list.length == 0" class="text-center my-5">No leads Available</h5>
          <div class="tableDiv lappyView">
            <table class="table" >
              <thead class="ss-thead">
                <tr>
                  <th class="firstTh" style="width: 30px;" >#</th>
      
                  <th class="text-center">NAME</th>
      
                  <th  class="text-center">MOBILE NUMBER</th>
      
                  <th  class="text-center">EMAIL ID</th>
      
                  <!-- <th>TOTAL LEAD ASSIGNED</th> -->
                </tr>
      
              </thead>
      
              <tbody class="ss-tbody" *ngIf="cm_list && cm_list.length > 0">
                  <tr *ngFor="let cm of cm_list; let i = index">
      
                  <td   style="width: 30px;">{{i+1}}</td>
                  <td class="text-center">{{cm.name}}</td>
                  <td class="text-center">{{cm.contact}}</td>
                  <td class="text-center">{{cm.email}}</td>
                </tr>
                
                  
              </tbody>
      
            </table>
            
          </div>
          </ng-container>
        </div>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/platform/organisation/catalogue/sales-manager/sales-manager.component.html